import React from 'react';

export const useTimer = () => {
  const [startTime, setStartTime] = React.useState<Date | null>(null);
  const [elapsedTime, setElapsedTime] = React.useState<number>(0);
  const [isTimerActive, setIsTimerActive] = React.useState<boolean>(false);

  const formatTime = (seconds: number): string => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    if (hours > 0) {
      return `${hours}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(
        2,
        '0',
      )}`;
    } else {
      return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`;
    }
  };

  React.useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (isTimerActive && startTime) {
      timer = setInterval(() => {
        const currentTime = new Date();
        const elapsedTimeInSeconds = Math.floor(
          (currentTime.getTime() - startTime.getTime()) / 1000,
        );
        setElapsedTime(elapsedTimeInSeconds);
      }, 1000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [isTimerActive, startTime]);

  const startTimer = React.useCallback(() => {
    setStartTime(new Date());
    setIsTimerActive(true);
  }, []);

  const endTimer = React.useCallback(() => {
    setStartTime(null);
    setIsTimerActive(false);
    setElapsedTime(0);
  }, []);

  return {
    isTimerActive,
    startTimer,
    endTimer,
    formattedTime: formatTime(elapsedTime),
  };
};
